module.exports = __webpack_public_path__ + "img/laprecision-logo-black.9fd2be8f.svg";